import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";
import useModalStore from "store/modal";
import useListRowInfStroe from "store/listRowInf";
import "./modal.scss";

// export interface IBaseModalProps extends React.ComponentPropsWithoutRef<"div"> {
//   isOpen: boolean;
//   title?: string;
//   styles?: string;
//   onClose: () => void;
//   children: ReactNode;
// }

export default function BaseModal() {
  const { t } = useTranslation();
  const resetListRowParams = useListRowInfStroe(
    (state) => state.resetListRowParams
  );

  const {
    title,
    isOpen,
    inner,
    chkBnt,
    cnclBtn,
    styles,
    chkBtnTex,
    cnclBtnTex,
    keep,
    onSetConfirm,
    onSetClose,
    handleModal,
  } = useModalStore();

  const onConfirm = () => {
    onSetConfirm && onSetConfirm();
    if (keep) return;
    if (!keep) {
      handleModal(false);
    }
  };

  const onClose = () => {
    resetListRowParams();
    handleModal(false);
    onSetClose && onSetClose();
  };

  useEffect(() => {
    if (isOpen) {
      window.document.body.style.overflow = "hidden";
    }
    return () => {
      window.document.body.style.overflow = "auto";
    };
  }, [isOpen, keep]);

  return (
    isOpen &&
    createPortal(
      <div className="modal-layout">
        <div className={`modal center overflow-auto ${styles}`}>
          {/* Modal Head -> 타이틀, close버튼*/}
          <div className="modal-title">
            <h3 className="">
              <span>{title}</span>
              <button onClick={onClose}>
                <IoClose size={28} color={""} style={{ marginTop: -15 }} />
              </button>
            </h3>
          </div>
          {/* Modal Body -> 내용*/}
          <div>{inner}</div>
          {/* Modal Footer -> 확인, 취소 버튼 영역*/}
          {(cnclBtn || chkBnt) && (
            <div className="flex justify-center gap-2 mt-5">
              <button
                className="btn bg-red-400 px-2"
                hidden={!chkBnt}
                onClick={onConfirm}
              >
                {t(chkBtnTex)}
              </button>
              <button
                className="btn bg-gray-300"
                hidden={!cnclBtn}
                onClick={onClose}
              >
                {t(cnclBtnTex)}
              </button>
            </div>
          )}
        </div>
      </div>,
      document.body
    )
  );
}
